import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
interface CTAButtonProps {
  text: string;
  className?: string;
  icon?: React.ReactNode;
}
export function CTAButton({
  text,
  className = '',
  icon
}: CTAButtonProps) {
  return <motion.a href="#compra" whileHover={{
    scale: 1.05
  }} whileTap={{
    scale: 0.95
  }} animate={{
    boxShadow: ['0px 0px 0px rgba(109, 190, 69, 0)', '0px 0px 20px rgba(109, 190, 69, 0.5)', '0px 0px 0px rgba(109, 190, 69, 0)']
  }} transition={{
    boxShadow: {
      duration: 2,
      repeat: Infinity
    },
    scale: {
      type: 'spring',
      stiffness: 400,
      damping: 10
    }
  }} className={`inline-flex items-center justify-center gap-2 bg-brand-accent hover:bg-brand-accentHover text-white font-heading font-bold py-4 px-8 rounded-full text-lg md:text-xl shadow-lg transition-colors uppercase tracking-wide ${className}`} data-id="element-35">
      {icon}
      {text}
      {!icon && <ArrowRight className="w-6 h-6" data-id="element-36" />}
    </motion.a>;
}